import {
    Box, Button, CardContent, FormControlLabel, Switch, TextField, Typography
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateField } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class MarcaVeiculoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNewRecord: false,
            isView: false,
            marcaveiculo: {},
            errors: {},
            schema: {
                descmarcaveiculo: {
                    presence: { allowEmpty: false, message: 'Descrição da marca obrigatória' },
                    length: { maximum: 64 },
                    type: 'string'
                }
            }
        };
    };

    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;

        try {
            if (!isNaN(Number(id))) {
                const response = await api.get(`/marcaveiculo/${id}`);
                const registro = response?.data?.data?.[0];

                if (!registro) {
                    this.handleOpenAlert('Marca de veículo não encontrada!');
                    this.props.history.push('/frotas/marcaveiculo');
                    return;
                }

                this.setState({
                    marcaveiculo: {
                        codmarcaveiculo: registro.codmarcaveiculo || '',
                        descmarcaveiculo: registro.descmarcaveiculo || '',
                        inativo: registro.inativo || ANAO
                    },
                    isNewRecord: false,
                    isView: (currentPath.includes('/view'))
                });
            } else if (id === 'novo') {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    marcaveiculo: {
                        codmarcaveiculo: '',
                        descmarcaveiculo: '',
                        inativo: ANAO
                    }
                });
            }
        } catch (error) {
            console.error('Erro ao carregar marca de veículo:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao carregar marca de veículo!');
        }
    };

    /* Evento on change componentes */
    OnChange = (event) => {
        const { name, type, value, checked } = event.target;

        // ajuste de campos (código existente)
        let adjustedValue =
            type === 'checkbox' ? (checked ? ANAO : ASIM) :
                type === 'radio' ? Number(value) : value.toUpperCase();

        this.setState(prevState => ({
            marcaveiculo: {
                ...prevState.marcaveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Atualiza dados de marca de veículo existente - post */
    atualizaMarcaVeiculo = async () => {
        const { marcaveiculo } = this.state;
        try {
            const response = await api.put(`/marcaveiculo/${marcaveiculo.codmarcaveiculo}`, marcaveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/marcaveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Click salvar */
    onClickSave = async () => {
        const { marcaveiculo, isNewRecord } = this.state;
        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        try {
            const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');
            if (!codusuarioregistrou) {
                console.error('Erro: código do usuário não encontrado!');
                return;
            }

            // usa-se quando não há campos do tipo BLOB
            const payload = {
                descmarcaveiculo: marcaveiculo.descmarcaveiculo || '',
                inativo: marcaveiculo.inativo || '',
                codusuarioregistrou: Number(codusuarioregistrou)
            };

            console.log('Enviando para o backend (JSON):', payload);

            if (isNewRecord) {
                await api.post('/marcaveiculo', payload);
            } else {
                await api.put(`/marcaveiculo/${marcaveiculo.codmarcaveiculo}`, payload);
            }

            if (this.props.loadMarcasVeiculo) this.props.loadMarcasVeiculo();
            this.props.history.push('/frotas/marcaveiculo');

        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao salvar!');
        }
    };

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/marcaveiculo');
    };

    /* Valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { marcaveiculo, schema } = this.state;
        let errors = {};

        // valida campos do schema
        const requiredFields = [
            'descmarcaveiculo'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, marcaveiculo[field], schema);
            if (error) {
                errors[field] = error;
            }
        })

        return errors;
    };

    /* Insere nova marca de veículo */
    insereMarcaVeiculo = async () => {
        const { marcaveiculo } = this.state;
        marcaveiculo.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/marcaveiculo`, marcaveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/marcaveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    render() {
        const {
            errors,
            isView,
            marcaveiculo,
            messageAlert,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Marca de veículos {marcaveiculo.codmarcaveiculo}
                        </Typography>

                        <FormControlLabel
                            label={(marcaveiculo.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={!(marcaveiculo.inativo === ASIM)}
                                    name="inativo"
                                    onChange={this.OnChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <TextField
                        label="Descrição"
                        name="descmarcaveiculo"
                        value={marcaveiculo.descmarcaveiculo || ''}
                        variant="outlined"
                        onChange={this.OnChange}
                        helperText={errors.descmarcaveiculo || ''}
                        error={!!errors.descmarcaveiculo}
                        disabled={isView}
                        inputProps={{ maxLength: 50 }}
                        style={{
                            marginTop: '10px',
                            width: '70%'
                        }}
                    />

                    <br />
                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div>
        );
    }
}

export default MarcaVeiculoForm;